var lib_core           = require("lib-core");
var FootprintSettingsView = require("./footprintSettingsView.js");

var PackageSettingsView = function(model, stateMachine, parentView, configuration, masterView) {
    var self = this;
    
    FootprintSettingsView.apply(this, arguments);

    this.masterView = masterView;

    if(this.masterView.model.wizardMode()) {
        //hide settings tab
        this.parentView.tabModel.button.hide();
    } else {
        //show settings tab
        this.parentView.tabModel.button.show();
    }

    this.masterView.model.wizardMode.onChange(this, function(mode) {
        if(!mode) {
            //show settings tab
            self.parentView.tabModel.button.show();
        }
    });
};

if(typeof window !== 'undefined') {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(PackageSettingsView, FootprintSettingsView);
}
module.exports = PackageSettingsView;
